"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

var _core = require("@popperjs/core");

var _elements = require("../../styles/elements");

var _hooks = require("../../hooks");

var _Tooltip = require("../Tooltip/Tooltip");

var _Title = _interopRequireDefault(require("./Title"));

var _FeatureCallout = require("./FeatureCallout.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FeatureCallout = function FeatureCallout(_ref) {
  var className = _ref.className,
      offset = _ref.offset,
      children = _ref.children,
      portal = _ref.portal,
      overlay = _ref.overlay,
      position = _ref.position,
      strategy = _ref.strategy,
      open = _ref.open;

  var _useChildRef = (0, _hooks.useChildRef)(children),
      child = _useChildRef.child,
      triggerRef = _useChildRef.triggerRef;

  var popperRef = (0, _react.useRef)(null);
  var popperInstanceRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    var _popperInstanceRef$cu;

    (_popperInstanceRef$cu = popperInstanceRef.current) === null || _popperInstanceRef$cu === void 0 ? void 0 : _popperInstanceRef$cu.destroy();
    popperInstanceRef.current = null;

    if (open) {
      var triggerElement = triggerRef.current;
      var popperElement = popperRef.current; // Save the popper instance

      popperInstanceRef.current = (0, _core.createPopper)(triggerElement, popperElement, {
        placement: position,
        strategy: strategy,
        modifiers: [{
          name: 'offset',
          options: {
            offset: typeof offset === 'number' ? [0, offset] : offset
          }
        }]
      }); // Should only show after update the position, otherwise the offset isn't correct for right position

      popperInstanceRef.current.update().then(function () {
        setVisible(true);
      });
    }

    return function () {
      var _popperInstanceRef$cu2;

      (_popperInstanceRef$cu2 = popperInstanceRef.current) === null || _popperInstanceRef$cu2 === void 0 ? void 0 : _popperInstanceRef$cu2.destroy();
      popperInstanceRef.current = null;
    };
  }, [position, strategy, triggerRef, open, offset]);
  (0, _react.useEffect)(function () {
    if (visible && popperInstanceRef.current) {
      // Enable the event listeners
      popperInstanceRef.current.setOptions(function (options) {
        return _objectSpread(_objectSpread({}, options), {}, {
          modifiers: [].concat((0, _toConsumableArray2["default"])(options.modifiers), [{
            name: 'eventListeners',
            enabled: true
          }])
        });
      });
    }
  }, [visible]);
  var content = (0, _jsxRuntime.jsxs)("div", {
    ref: popperRef,
    className: className,
    css: [_elements.text.styles.textSm, _FeatureCallout.styles.base, visible && _FeatureCallout.styles.show, process.env.NODE_ENV === "production" ? "" : ";label:content;"],
    children: [overlay, (0, _jsxRuntime.jsx)("div", {
      "data-popper-arrow": true,
      css: _FeatureCallout.styles.arrow,
      className: "feature-callout-arrow"
    })]
  });
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [child, portal ? /*#__PURE__*/_reactDom["default"].createPortal(content, document.querySelector(portal)) : content]
  });
};

FeatureCallout.propTypes = {
  children: _propTypes.node,
  overlay: _propTypes.node,
  position: (0, _propTypes.oneOf)(_Tooltip.positions),
  className: _propTypes.string,
  offset: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array]),

  /**
   * Tooltip's position style value
   */
  strategy: (0, _propTypes.oneOf)(['absolute', 'fixed']),
  portal: _propTypes.string,
  open: _propTypes.bool
};
FeatureCallout.defaultProps = {
  children: undefined,
  overlay: undefined,
  className: undefined,
  position: 'top',
  offset: 8,
  strategy: 'absolute',
  portal: undefined,
  open: false
};
FeatureCallout.Title = _Title["default"];
var _default = FeatureCallout;
exports["default"] = _default;
//# sourceMappingURL=FeatureCallout.js.map